import { waves } from '@mentimeter/sfinx-themes';

export const WavesBackground = waves.background;
